<div class="wrapper d-flex flex-column">
    <div class="header d-flex row align-items-center">
        <div class="col-md-9">
            <h6 class="px-4 py-3">Fiter Criteria</h6>
        </div>
        <div class="header-action-btn col-md-3 d-flex align-items-center justify-content-end pr-2">

            <button nz-button nzType="primary" (click)="updateFilterCriteria()">Save</button>
        </div>
    </div>
    <div class="form-container px-4 row g-3">
        <div class="form-check px-4">
            <input class="form-check-input" [(ngModel)]="sizeAvailable" type="checkbox">
            <label class="form-check-label"> Filter by Availability</label>
        </div>
        <div class="form-check px-4">
            <input class="form-check-input" [(ngModel)]="byGender" type="checkbox">
            <label class="form-check-label">Filter by Gender</label>
        </div>
    </div>
</div>